import { Row as RowI } from '@abiglobalhealth/go-types'

import { useGetComponent } from '@/hooks/useGetComponent'

export type RowProps = Omit<
  RowI & {
    tabIndex: number
  },
  'componentType'
>

export const Row = ({ id, components, tabIndex }: RowProps) => {
  const { getComponent } = useGetComponent()

  const shownComponents = components.filter((component) => getComponent(component))
  const componentsLength = shownComponents.length
  return (
    <div className="flex flex-row flex-wrap gap-4" data-testid={`row-${id}`}>
      {shownComponents.map((subComponent, index) => {
        const Component = getComponent(subComponent)

        if (!Component) return null

        const subComponentTabIndex = Math.abs(tabIndex - componentsLength + index) + 1

        return (
          <span key={subComponent.id} className="flex-1">
            <Component {...subComponent} tabIndex={subComponentTabIndex} isInRow={componentsLength > 1} />
          </span>
        )
      })}
    </div>
  )
}
